import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import { PASearch, ISearchRequest } from "../PA.Core/PASearch";
import { SearchUtils } from "../PA.UIM.Core/SearchUtils";
import { PAEnvironment } from "../PA.Core/PAEnvironment";
import { CustomerSearch } from "../PA.UIM.MD/CustomerSearch";
import * as _ from "lodash";


const EventTacticSearch: ISearch = {
    searchName: "Find Event Tactic",
    renderOptions: { ui5ResourceId: "EventTacticSearch" },
    searchProfileIdDefault: "default",
    searchProfiles: []
}

const vUI_Event_Tactic_Search_Fields: { [id: string]: ISearchProviderField } = {

    WB_EVT_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: { columnName: 'WB Event Id', columnResourceName: 'colwbId', alignment: HorizAlignment.Center },
        domainOptions: {}
    },
    EVENT_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Event ID', columnResourceName: 'colId', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 50 }
    },
    EVENT_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Event Name', columnResourceName: 'colName', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 256 }
    },
    WB_PLAN_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'WB Plan Id',
            columnResourceName: 'colwbPlanId',
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    EVENT_TYPE_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Event Type ID',
            columnResourceName: 'colEventTypeID',
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    TYPE_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Event Type',
            columnResourceName: 'colEventTypeName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            search: EventTacticSearch,
            profileId: "default",
            bUseSearchProvidersDistinctValues: true,
            maxLength: 256
        }
    },
    TYPE_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Event Type',
            columnResourceName: 'colEventTypeName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    EVENT_SPEND_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Tactic ID', columnResourceName: 'colTacticID', alignment: HorizAlignment.Left },
        domainOptions: {}
    },
    EVENT_SPEND_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Tactic', columnResourceName: 'colTacticName', alignment: HorizAlignment.Left },
        domainOptions: {}
    },
    WB_EVTS_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'Tactic WB Id',
            columnResourceName: 'colTacticWbId',
            alignment: HorizAlignment.Center
        },
        domainOptions: { search: CustomerSearch, profileId: "MyPlanningCustomers", searchCondition: {} }
    },
    WB_SPENDM_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'Tactic Type Wb Id',
            columnResourceName: 'colTacticTypewbId',
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    SPEND_TYPE_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Tactic Type Id',
            columnResourceName: 'colTacticTypeId',
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 256 }
    },
    SPEND_TYPE_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Tactic Type',
            columnResourceName: 'colTacticTypeName',
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 256 }
    },

    PAYMENT_METHOD_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Payment Method',
            columnResourceName: 'colPaymentMethodId',
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 50 }
    },
    PAYMENT_METHOD_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Payment Method Name',
            columnResourceName: 'colPaymentMethodName',
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 50 }
    },

    RATE_BASIS_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Rate Basis', columnResourceName: 'colRateBasis', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 50 }
    },
    RATE_UOM: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'UOM', columnResourceName: 'colUOM', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 50 }
    },

    INSTORE_START_DT: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'In Store Start Date',
            columnResourceName: 'colInStoreStart',
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    INSTORE_END_DT: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'In Store End Date',
            columnResourceName: 'colInStoreEnd',
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    SHIPMENT_START_DT: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Shipment Start Date',
            columnResourceName: 'colShipmentStart',
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    SHIPMENT_END_DT: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Shipment End Date',
            columnResourceName: 'colShipmentEnd',
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    }

}

const EventTacticSearchProviderBasic: ISearchProvider = {
    keyFields: {
        id: 'WB_EVTS_ID',
        id_ui: 'EVENT_SPEND_ID',
        name: 'EVENT_SPEND_NAME'
    },

    searchProviderFields: vUI_Event_Tactic_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {
            const findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Event_Tactic_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err) => {
                    error(err)
                })

        })
    },

    // Filter with drop down in the TPM Event Search
    distinctValues(fieldName: string): Promise<string[] | number[]> {
        return new Promise<string[] | number[]>((resolve, error) => {
            const findRequest = SearchUtils.makeSearchRequest({},
                'vUI_Event_Tactic_Search',
                this.searchProviderFields,
                [fieldName])
            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(_.map(res, (aRow) => {
                        return aRow[fieldName]
                    }))
                })
                .catch((err) => {
                    error(err)
                })
        })
    }
}

const EventSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Tactic Id, Name",
    renderOptions: { ui5ResourceId: "EventTacticSearchProfileByName" },

    profileFilter: [
        { profileFilterName: 'Tactic ID', searchProviderFieldId: 'EVENT_SPEND_ID', renderOptions: {} },
        { profileFilterName: 'Event ID', searchProviderFieldId: 'EVENT_ID', renderOptions: {} },
        { profileFilterName: 'Event Name', searchProviderFieldId: 'EVENT_NAME', renderOptions: {} },
        {
            profileFilterName: 'Event Type',
            searchProviderFieldId: 'TYPE_NAME',
            bMultiSelect: true,
            renderOptions: {}
        }
    ],  // ISearchFields
    profileDisplayFields: [
        'EVENT_ID', 'EVENT_NAME', 'TYPE_NAME', 'EVENT_SPEND_ID', 'INSTORE_START_DT', 'INSTORE_END_DT', 'SHIPMENT_START_DT', 'SHIPMENT_END_DT', 'SPEND_TYPE_NAME', 'RATE_BASIS_ID', 'RATE_UOM', 'PAYMENT_METHOD_ID'
    ],

    profileSearchProvider: EventTacticSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}

EventTacticSearch.searchProfiles = [EventSearchProfileByName]


export { EventTacticSearch }